import { GetterTree } from "vuex";
import { IServiceProviderState } from ".";
import { IRootState } from "@/store/types";
import { IServiceProvider } from "@/models/serviceprovider";

export const getters: GetterTree<IServiceProviderState, IRootState> = {
    serviceProvidersList(state): IServiceProvider[] | null {
        return state.serviceProvidersList;
    },
    selectedServiceProvider(state): IServiceProvider | null {
        return state.selectedServiceProvider;
    },
    isSelectedServiceProvider(state): boolean {
        return state.isSelectedServiceProvider;
    },
};
